const styles = {
  mainContainer: {
    outline: 'none',
    minWidth: '46vw',
    maxWidth: '42vw',
    border: 'thin solid rgba(33, 71, 150, 0.1)',
    borderRadius: '10px'
    // width: '158px'
    // width: '148px',
    // marginTop: '1.5em'
  },
  disabledMainContainer: {
    outline: 'none',
    backgroundColor: 'rgba(239, 239, 239, 0.3)'
  },
  container: {

    // height: '4.143em',
    // borderBottom: '0.6px solid #D7D7D7'
    // border: '0.6px solid #D7D7D7',
    // borderRadius: '10px'
  },
  textField: {
    fontSize: '0.875em',
    fontWeight: '300',
    marginTop: '20px',
    borderTop: 0,
    borderLeft: 0,
    borderRight: 0,
    borderBottom: '1px solid',
    borderColor: '#959595',
    // width: '158px',
    marginBottom: '15px',
    '&:focus': {
      'outline': 'none'
    },
    fontFamily: 'JioType-Light',
    '&:disabled': {
      backgroundColor: 'transparent'
    }
  },
  noData: {
    listStyle: 'none',
    marginTop: '-5px',
    overflow: 'scroll',
    paddingLeft: '1em',
    width: '158px',
    boxShadow: '0rem 0rem 0.875rem #2147961A',
    borderRadius: '5px',
    backgroundColor: '#FFFFFF',
    position: 'absolute',
    zIndex: '1',
    color: '#7D7D7D'
  },
  suggestions: {
    listStyle: 'none',
    marginTop: '-5px',
    overflow: 'scroll',
    paddingLeft: 0,
    maxHeight: '200px',
    height: 'fit-content',
    width: '158px',
    boxShadow: '0rem 0rem 0.875rem #2147961A',
    borderRadius: '5px',
    backgroundColor: '#FFFFFF',
    position: 'absolute',
    zIndex: '1',
    color: '#7D7D7D',
    outline: 'none'
  },

  noSuggestions: {
    color: '#959595',
    padding: '0.3rem'
  },
  list: {
    padding: '0.5rem 0.5rem 0rem 0.5rem',
    fontFamily: 'JioType-Medium',
    fontSize: '12px',
    height: 'fit-content',
    marginBottom: '0.5rem',
    width: '100%',
    color: '#7D7D7D'
  },
  listDiv: {
    paddingLeft: '0.5em',
    textDecoration: 'none',
    outline: 'none',
    background: 'none',
    border: 'none',
    width: '100%',
    borderBottom: '0.6px solid #D7D7D7',
    height: '46px',
    display: 'flex',
    alignItems: 'center',
    // justifyContent: 'center',
    color: '#7D7D7D',
    '&:hover': {
      backgroundColor: '#E5E9F7',
      cursor: 'pointer'
    }
  },
  listDivWithData: {
    paddingLeft: '0.5em',
    textDecoration: 'none',
    outline: 'none',
    background: 'none',
    border: 'none',
    width: '100%',
    borderBottom: '0.6px solid #D7D7D7',
    height: '46px',
    display: 'flex',
    alignItems: 'center',
    // justifyContent: 'center',
    backgroundColor: '#E5E9F7',
    color: '#000000',
    '&:hover': {
      backgroundColor: '#E5E9F7',
      cursor: 'pointer'
    }
  },
  listCheckBox: {
    padding: '0.5rem 0.5rem 0rem 0.5rem',
    fontFamily: 'JioType-Medium',
    fontSize: '12px',
    height: 'fit-content',
    marginBottom: '0.5rem',
    width: '100%',
    color: '#000000'
  },
  downArrow: {
    height: '14px',
    width: '14px'
  },
  textWithArrow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    height: '4em',
    padding: '12px',
    fontSize: '12px',
    color: '#000000',
    outline: 'none'
  },
  labelWithArrow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    height: '4em',
    padding: '12px',
    fontSize: '12px',
    color: '#7D7D7D',
    outline: 'none'
  },
  label: {
    fontSize: '14px',
    fontFamily: ' JioType-Medium',
    color: '#7D7D7D'
  },
  labelCheckbox: (isSelected) => {
    return ({
      fontSize: '12px',
      fontFamily: ' JioType-Medium',
      color: isSelected ? '#000000' : '#7D7D7D'
    })
  },
  value: {
    fontSize: '14px',
    fontFamily: ' JioType-Medium',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    width: '160px',
    whiteSpace: 'nowrap'
  },
  errorMsgContainer: {
    fontFamily: 'JioType-Medium',
    position: 'absolute',
    fontSize: '12px',
    color: '#EB0000',
    paddingRight: '12px',
    width: 'fit-content',
    paddingTop: '2rem'
  },
  errorMsgContainerLengthy: {
    fontFamily: 'JioType-Medium',
    position: 'absolute',
    fontSize: '11px',
    color: '#EB0000',
    width: '94%',
    paddingRight: '12px',
  },
  keywordsFlexboxElement: {
    backgroundColor: '#F6F6F6',
    padding: '12px',
    borderRadius: '8px',
    marginBottom: '8px'
  },
  relLabelAfter: {
    color: '#959595',
    fontSize: '12px',
    fontFamily: 'JioType-Light',
    paddingLeft: '16px',
    width: '100%',
    paddingTop: '0.5em'
  }
}

export { styles }
